import React, { useState } from "react";
import axiosInstance from "../../../utils/axiosConfig";
import Select from "react-select";
import { TailSpin } from "react-loader-spinner";
import CashbackPoolTable from "./CashbackPoolTable";
import { API_URL } from "../../../constant";
import toast from "react-hot-toast";

const RewardSettings = () => {
  const [rewardAmount, setRewardAmount] = useState<string>("");
  const [targetAmount, setTargetAmount] = useState<string>("");
  const [refetchCount, setRefetchCount] = useState<number>(0);
  const [duration, setDuration] = useState<any>("");
  const [status] = useState<"ongoing" | "inactive">("ongoing");
  const [saving, setSaving] = useState<boolean>(false);
  const isNumber = (str: string) => /^\d*\.?\d*$/.test(str); // Allows numbers and decimals
  const formatWithCommas = (value: string) => {
    if (value === "") return "";
    const [intPart, decPart] = value.split(".");
    const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return decPart !== undefined ? `${withCommas}.${decPart}` : withCommas;
  };
  const handleAmtChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/,/g, ""); // Remove commas for parsing
    if (isNumber(raw)) {
      setRewardAmount(formatWithCommas(raw)); // Store formatted amount
    }
  };
  const handleTargetAmtChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/,/g, ""); // Remove commas for parsing
    if (isNumber(raw)) {
      setTargetAmount(formatWithCommas(raw)); // Store formatted amount
    }
  };
  const options = [
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "yearly", label: "Yearly" },
  ];

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      borderRadius: "8px",
      border: "1px solid #141414",
      backgroundColor: "#1C2227",
      padding: "0 6px",
      height: "46px",
      boxShadow: "none",
      fontSize: "14px",
      color: "#A0A9AD",
      margin: "8px 0px",
      minHeight: "46px",
    }),
    menu: (provided: any) => ({
      ...provided,
      borderRadius: "8px",
      boxShadow: "none",
      marginTop: "0",
      padding: "0",
      backgroundColor: "#1C2227", // Keeps the same background color
    }),
    menuList: (provided: any) => ({
      ...provided,
      padding: "0",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#1C2227" : "#1C2227",
      color: "#A0A9AD",
      padding: "10px 16px",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "#AEBCC6",
        color: "#1C2227",
      },
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: "#A0AEC0",
      fontSize: "14px",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#A0A9AD",
    }),
    input: (provided: any) => ({
      ...provided,
      color: "#A0A9AD", // Ensures typed text matches the dropdown text color
      backgroundColor: "transparent", // Keeps the input background transparent
    }),
    noOptionsMessage: (provided: any) => ({
      ...provided,
      backgroundColor: "#1C2227", // Keeps the background consistent
      color: "#A0A9AD", // Matches the text color
      padding: "10px", // Adds padding for better UI
    }),
  };

  return (
    <div className="p-4 mds:p-6 lgss:p-8  overflow-auto scrollbar-thumb-[#60B7F6] scrollbar-track-white  scrollbar-thin  ">
      <div className="w-full lgss:w-[50%] lg:w-[40%] flex flex-col justify-start items-start">
        <h4 className="text-[20px] font-bold font-sora text-white">
          Cash Pool
        </h4>
        <div className="w-full flex flex-col    ">
          <div className="mt-4">
            <label className=" font-bold text-[14px] text-white">
              Reward Amount
            </label>
            <div className="w-full flex justify-start mt-2 items-center gap-1  px-4   text-gray-200   bg-[#1C2227] border-[#141414]  h-[48px]   font-manrope border rounded-[8px]  outline-none    transition duration-200">
              <h4>₦</h4>
              <input
                type="text" // Changed to "text" to allow formatted input
                placeholder=" 50,000"
                value={rewardAmount} // Show formatted amount or raw input
                onChange={handleAmtChange}
                className="w-full outline-none py-3 text-[14px] text-gray-200 placeholder:text-gray-500 bg-transparent"
              />
            </div>
          </div>
          <div className="mt-6">
            <label className=" font-bold text-[14px] text-white">
              Target Amount
            </label>
            <div className="w-full flex justify-start mt-2 items-center gap-1  px-4   text-gray-200   bg-[#1C2227] border-[#141414]  h-[48px]   font-manrope border rounded-[8px]  outline-none    transition duration-200">
              <h4>₦</h4>
              <input
                type="text" // Changed to "text" to allow formatted input
                placeholder="2,000,000"
                value={targetAmount} // Show formatted amount or raw input
                onChange={handleTargetAmtChange}
                className="w-full outline-none py-3 text-[14px] text-gray-200 placeholder:text-gray-500 bg-transparent"
              />
            </div>
          </div>
          <div className="mt-6">
            <label className=" font-bold text-[14px] text-white">
              Duration
            </label>

            <Select
              options={options}
              styles={customStyles}
              onChange={(option: any) => setDuration(option)}
            />
          </div>
          <button
            disabled={
              saving || !rewardAmount || !targetAmount || !duration?.value
            }
            onClick={async () => {
              if (saving) return;
              try {
                setSaving(true);
                const payload = {
                  cashbackAmount: Number(rewardAmount.replace(/,/g, "")) || 0,
                  targetAmount: Number(targetAmount.replace(/,/g, "")) || 0,
                  duration: duration?.value, // "weekly" | "monthly" | "yearly"
                  status, // default to ongoing for now
                };
                await axiosInstance.put(
                  `${API_URL}api/admin/cashback`,
                  payload
                );
                toast.success("Cashback settings saved successfully");
                // Optional: reset inputs
                setRewardAmount("");
                setTargetAmount("");
                setDuration("");
                setRefetchCount((prev: number) => prev + 1);
              } catch (e: any) {
                console.log(
                  e?.response?.data?.message ??
                    "Failed to save cashback settings"
                );
              } finally {
                setSaving(false);
              }
            }}
            className="w-full h-[46px] flex justify-center items-center font-manrope font-medium rounded-[8px] text-white bg-secondary_button mt-4 lgss:mt-4 disabled:opacity-60"
          >
            {saving ? (
              <TailSpin color="#FFFFFF" height={30} width={30} />
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
      <CashbackPoolTable
        refetchCount={refetchCount}
        setRefetchCount={setRefetchCount}
      />
    </div>
  );
};

export default RewardSettings;
